var _ellipse, _ellipse2, _g, _ellipse3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0722,
    cy: 80,
    rx: 80.0722,
    ry: 80,
    fill: "#F3F3F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2838_150966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 161,
    height: 160
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.1038,
    cy: 80,
    rx: 80.0722,
    ry: 80,
    fill: "#EFF1F3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2838_150966)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0316162,
    y: 99.0862,
    width: 160.144,
    height: 63.3503,
    fill: "#DEDEE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2838_150966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 161,
    height: 160
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0722,
    cy: 80,
    rx: 80.0722,
    ry: 80,
    fill: "#EFF1F3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2838_150966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1495 37.9524C28.9846 32.0473 23.7937 27.6143 17.5578 27.6143C12.6068 27.6143 8.30681 30.4213 6.16537 34.5292C1.00878 35.0769 -3 39.4415 -3 44.7303C-3 50.3958 1.60838 55 7.27892 55H29.5499C34.2782 55 38.1157 51.166 38.1157 46.442C38.1157 41.9233 34.6037 38.2605 30.1495 37.9524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2224 18.0993C54.7387 15.6475 52.5835 13.8069 49.9944 13.8069C47.9387 13.8069 46.1533 14.9724 45.2642 16.678C43.1232 16.9054 41.4587 18.7175 41.4587 20.9135C41.4587 23.2658 43.3721 25.1774 45.7265 25.1774H54.9735C56.9367 25.1774 58.53 23.5856 58.53 21.6241C58.53 19.748 57.0718 18.2272 55.2224 18.0993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9732 37.3014C82.2362 33.6237 78.952 30.8628 75.0066 30.8628C71.8742 30.8628 69.1537 32.611 67.7988 35.1694C64.5363 35.5105 62 38.2288 62 41.5227C62 45.0511 64.9157 47.9186 68.5033 47.9186H82.5939C85.5854 47.9186 88.0133 45.5308 88.0133 42.5887C88.0133 39.7745 85.7913 37.4933 82.9732 37.3014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.351 37.2818C133.426 31.9801 138.216 28 143.97 28C148.539 28 152.507 30.5202 154.483 34.2084C159.241 34.7001 162.94 38.6188 162.94 43.3672C162.94 48.4538 158.688 52.5876 153.455 52.5876H132.904C128.541 52.5876 125 49.1453 125 44.904C125 40.847 128.241 37.5584 132.351 37.2818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7445 60.4949H53.0466C49.6186 60.4949 46.8451 63.2657 46.8451 66.6522L46.814 103.596C46.814 106.983 49.6186 109.753 53.0466 109.753H102.908C106.336 109.753 109.14 106.983 109.14 103.596V72.8095C109.14 69.423 106.336 66.6522 102.908 66.6522H77.9771L71.7445 60.4949Z",
    fill: "#A6A8BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.814 105.106V105.106V99.5298L53.3256 103.247C55.4962 107.275 59.0932 115.33 56.1164 115.33C52.3954 115.33 51.0001 114.4 48.6745 111.612C46.814 109.382 46.814 106.965 46.814 105.106Z",
    fill: "#A6A8BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0662 72.2293V72.2288C51.0662 69.1209 53.6134 66.5715 56.7677 66.5715H75.2602L81.3468 72.5845L81.4929 72.7288H81.6982H106.629C109.786 72.7288 112.361 75.2815 112.361 78.3861V109.173C112.361 112.277 109.786 114.83 106.629 114.83H56.7677C53.6101 114.83 51.035 112.277 51.035 109.173L51.0662 72.2293Z",
    fill: "#CDCEDE",
    stroke: "#A6A8BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.6433,
    y: 25.1775,
    width: 41,
    height: 30,
    rx: 4,
    fill: "#A6A8BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.146 45.3035C96.026 45.3035 95.1674 44.8695 94.57 44.0015C93.9727 43.1335 93.674 41.8782 93.674 40.2355C93.674 38.5835 93.9727 37.3282 94.57 36.4695C95.1674 35.6108 96.026 35.1815 97.146 35.1815C98.2754 35.1815 99.134 35.6108 99.722 36.4695C100.319 37.3282 100.618 38.5788 100.618 40.2215C100.618 41.8735 100.319 43.1335 99.722 44.0015C99.1247 44.8695 98.266 45.3035 97.146 45.3035ZM97.146 44.2955C97.93 44.2955 98.5134 43.9642 98.896 43.3015C99.2787 42.6388 99.47 41.6122 99.47 40.2215C99.47 38.8215 99.2787 37.7995 98.896 37.1555C98.5134 36.5022 97.93 36.1755 97.146 36.1755C96.3714 36.1755 95.788 36.5022 95.396 37.1555C95.0134 37.8088 94.822 38.8308 94.822 40.2215C94.822 41.6122 95.0134 42.6388 95.396 43.3015C95.788 43.9642 96.3714 44.2955 97.146 44.2955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7291 61.7633L90.3149 56.3491C89.5647 55.5989 88.5473 55.1775 87.4865 55.1775H106.8C105.739 55.1775 104.722 55.5989 103.972 56.3491L98.5575 61.7633C97.7765 62.5443 96.5101 62.5443 95.7291 61.7633Z",
    fill: "#A6A8BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFile);
export default __webpack_public_path__ + "static/media/empty_file.184ff36d167ca99e1f8bdb9a4d8a8166.svg";
export { ForwardRef as ReactComponent };